import { Link } from 'react-router-dom';
import { styled } from 'stitches';
import { CenterLayout } from '../../../../shared/components/CenterLayout/CenterLayout.style';

export const Nav = styled('nav', {
	display: 'flex',
	flexDirection: 'column',
});

export const NavLinkIcon = styled('div', {
	width: '40px',
	height: '40px',
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	marginLeft: '14px',
	borderRadius: '50%',
})

export const NavLinkText = styled('span', {
	opacity: 1,
	transition: 'opacity 0.2s ease-in',
	transitionDelay: '0.2s',
	fontSize: '1rem',
	fontFamily: '$regular',
	whiteSpace: 'nowrap',
});

export const NavLink = styled(Link, {
	color: '#000',
	display: 'flex',
	alignItems: 'center',
	textDecoration: 'none',
	marginLeft: '-24px',
	cursor: 'pointer',
	fontSize: '1rem',
	height: 48,
	borderRadius: '0 $xlarge $xlarge 0',
	marginBottom: 4,
	'&:focus': {
		outline: 'none',
	},
	'&:hover': {
		backgroundColor: 'rgba(0,0,0,0.05)',
	},
	variants: {
		active: {
			true: {
				color: '$indigoDark',
				backgroundColor: '$indigo08',
				cursor: 'default',
				fontFamily: '$semiBold',
				'&:hover': {
					backgroundColor: '$indigo08',
				},
			},
		},
		collapsed: {
			true: {
				'&:hover': {
					backgroundColor: 'transparent',
				},
				[`&:hover ${NavLinkIcon}`]: {
					backgroundColor: 'rgba(0,0,0,0.05)',
				},
				[`& ${NavLinkText}`]: {
					opacity: 0,
					transition: 'opacity 0.2s ease-out',
					transitionDelay: '0s',
				},
			},
		},
	},
	compoundVariants: [
		{
			active: true,
			collapsed: true,
			css: {
				backgroundColor: "transparent",
				"&:hover": {
					backgroundColor: "transparent",
				},
				[`& ${NavLinkIcon}`]: {
					backgroundColor: "$indigo08",
				},
				[`&:hover ${NavLinkIcon}`]: {
					backgroundColor: "$indigo08",
				},
			},
		},
	],
});

export const NavLinkContent = styled('div', {
	display: 'flex',
	gap: '$1',
	justifyContent: 'flex-start',
	alignItems: 'center',
  fontFamily: '$regular',
});

export const StyledSidebar = styled(CenterLayout, {
	width: '100%',
	height: '100%',
	padding: '$2 $3',
	display: 'flex',
	justifyContent: 'space-between',
	gridArea: 'sidebar',
});

export const SelectContainer = styled('div', {
	marginBottom: '$3',
	opacity: 1,
	maxHeight: '60px',
	transition: 'opacity 0.2s ease-in, max-height 0.2s ease-in, margin-bottom 0.2s ease-in',
	transitionDelay: '0.2s',
	variants: {
		collapsed: {
			true: {
				opacity: 0,
				maxHeight: 0,
				overflow: 'hidden',
				marginBottom: 0,
				transition: 'opacity 0.2s ease-out, max-height 0.2s ease-out, margin-bottom 0.2s ease-out',
				transitionDelay: '0s',
			}
		}
	}
});
